<!--
    课件管理-擎想系统课件管理
    作用：展示擎想系统课件列表数据、课件预览权限
    组件:IMTable
-->
<template>
  <div>
    <IMTable
      :is-loading="isLoading"
      :is-page="true"
      :is-search="true"
      :table-head.sync="tableHead"
      :table-data.sync="tableData"
      :pagination="{
        currentPage: meta.current_page,
        pageSize: meta.per_page,
        total: meta.total
      }"
      :filterOptions="newFilterFields"
      @onTdBox="onTdBox"
      @onFilterComp="onFilterComp"
      @currentChange="currentChange"
      @onSearch="onSearch"
    />
  </div>
</template>

<script>
import { tableData, tableHead, filterFields } from './fields';

export default {
  name: 'Courseware',
  data() {
    return {
      isLoading: false,
      tableHead,
      tableData,
      newFilterFields: filterFields, // 过滤条件集
      meta: {
        current_page: 1,
        per_page: 15,
        total: 1,
      },
      subject_id: '', // 学科
      structure_id: '', // 结构
      name: '' // 课时名称
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      // 获取筛选列表数据
      this.getSubjectData()
      this.flashData();
    },
    // 获取学科
    async getSubjectData(){
      const res = await this.$http.get('api/imkid/subject')
      console.log(res)
      this.newFilterFields[0][0].options = res.items.map(v=>{
        return {
          key: `${v.id}`,
          value: v.name
        }
      })
    },
    // 获取目录
    async getStructureData({subject_id}){
      const res = await this.$http.get(`api/imkid/structure_tree/${subject_id}`)
      console.log(res)
      const arr = res.structureTree.map(v=>{
        return {
          key: `${v.id}`,
          value: v.name,
          childrens: v.children
        }
      })
      this.newFilterFields[1][0].options = this.$utils.FormatData(arr)
    },
    // 筛选过滤
    onFilterComp (target, item, index) {
      console.log('当前表格筛选==>', target, item, index)
      switch (target.attr) {
        case 'subject_id':
          this.subject_id = item[0].value
          // 更新结构列表
          this.getStructureData({subject_id: this.subject_id})
          this.structure_id = ''
          this.newFilterFields[0][0].value = ''
          this.flashData()
          break
        case 'structure_id':
          if(Array.isArray(item[0].value)) {
            this.structure_id = item[0].value[item[0].value.length - 1]
            this.flashData()
          }
          break
        case 'name':
          this.name = item[0].value
          break
      }
      // this.flashData()
    },// 表格单元操作
    async onTdBox (value, item, row) {
      console.log('当前表格单元数据==>', value, item, row)
      switch (item.prop) {
        case 'preview': {
          // 修改课件
          const param = { preview: value ? 1 : 0 }
          // const url = `/api/courseware/result/${row.id}`
          const url = `/api/course/${row.id}`
          const res = await this.$http.patch(url, param)
          if(res && res.status_code === 200) {
            this.$message.success('设置成功')
            this.flashData()
          }else{
            this.$message.error('设置失败')
            row.preview = !value
          }
          break
        }
      }
    },
    // 翻页
    currentChange(page) {
      this.flashData(page);
    },
    async flashData(newPage) {
      let page = 1;
      if (newPage) {
        page = newPage;
      }
      this.isLoading = true;
      let url = '/api/imkid/course?';
      if (this.search) url += `&like[name]=${this.search}`;
      if(this.subject_id) url += `&equal[subject_id]=${this.subject_id}`
      if(this.structure_id) url += `&equal[structure_id]=${this.structure_id}`
      if (page) url += `&page=${page}`;
      const res = await this.$http.get(url);
      console.log('校区列表==>', res);
      const arr = res.items.map(v => ({
        ...v,
        name: v.name,
        title: v.title,
        unit_name: v.unit_name,
        knowledge_content: v.knowledge_content,
        created_at: v.create_date,
        updated_at: v.update_date,
        courseware_status: v.courseware_status === 1 ? '未完成' : '已完成',
        pack_status: v.pack_status === 1 ? '准备更新' : v.pack_status === 2 ? '更新中' : '更新完成',
        preview: (v.course_extend && v.course_extend.preview === 1) ? true: false
      }));
      this.meta = {
        current_page: res.meta.current_page,
        per_page: res.meta.per_page,
        total: res.meta.total,
      };
      this.tableData = arr;
      this.isLoading = false;
    },
    onSearch(value) {
      this.search = value;
      this.flashData();
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Courseware/manage/index.vue